import React from "react";
import NFCReader from "./NFCReader";
import NFCWriter from "./NFCWriter";

function NFCPage() {
  return (
    <div>
      <h2>NFC Reader/Writer</h2>
      <NFCReader />
      <NFCWriter />
    </div>
  );
}

export default NFCPage;
